const indexes = {
    mean: {
        work: 7.5,
        collaboration: 6.5,
        wellbeing: 6.9,
    },
    globalBaseline: {
        overall: 4.3,
        wellbeing: 8.2,
        work: 4.1,
        collaboration: 3.8,
    },
    orgBaseline: {
        overall: 5.5,
        wellbeing: 7.2,
        work: 6.4,
        collaboration: 5.9,
    },
    timeseries: [
        {
            datetime: "2023-06-05 00:00:00",
            wellbeing: 8.75,
            rank: "175",
            collaboration: 1.5,
            work: 1.066,
            overall: 3.385,
        },
        {
            datetime: "2023-06-06 00:00:00",
            work: 2.916,
            rank: "158",
            wellbeing: 8.625,
            collaboration: 2.85,
            overall: 4.528,
        },
        {
            datetime: "2023-06-07 00:00:00",
            collaboration: 2.95,
            rank: "164",
            overall: 4.68,
            work: 3.244,
            wellbeing: 8.566,
        },
        {
            datetime: "2023-06-08 00:00:00",
            overall: 4.825,
            rank: "163",
            collaboration: 3.487,
            wellbeing: 8.025,
            work: 3.583,
        },
        {
            datetime: "2023-06-09 00:00:00",
            wellbeing: 8.1,
            rank: "151",
            work: 3.82,
            overall: 5.068,
            collaboration: 3.91,
        },
        {
            datetime: "2023-06-10 00:00:00",
            wellbeing: 8.1,
            rank: "155",
            collaboration: 3.91,
            work: 3.966,
            overall: 5.131,
        },
        {
            datetime: "2023-06-11 00:00:00",
            collaboration: 3.91,
            rank: "152",
            overall: 5.153,
            work: 4.019,
            wellbeing: 8.1,
        },
        {
            datetime: "2023-06-12 00:00:00",
            work: 4.624,
            rank: "134",
            collaboration: 4.78,
            overall: 5.476,
            wellbeing: 7.45,
        },
        {
            datetime: "2023-06-13 00:00:00",
            work: 5.184,
            rank: "130",
            overall: 5.647,
            wellbeing: 6.93,
            collaboration: 5.06,
        },
        {
            datetime: "2023-06-14 00:00:00",
            overall: 5.996,
            rank: "115",
            collaboration: 5.64,
            work: 6.044,
            wellbeing: 6.28,
        },
        {
            datetime: "2023-06-15 00:00:00",
            collaboration: 5.47,
            rank: "105",
            overall: 6.09,
            wellbeing: 6.41,
            work: 6.291,
        },
        {
            datetime: "2023-06-16 00:00:00",
            collaboration: 5.03,
            rank: "118",
            work: 6.684,
            wellbeing: 5.91,
            overall: 5.99,
        },
        {
            datetime: "2023-06-17 00:00:00",
            work: 6.736,
            rank: "119",
            overall: 6.012,
            wellbeing: 5.91,
            collaboration: 5.03,
        },
        {
            datetime: "2023-06-18 00:00:00",
            work: 6.762,
            rank: "114",
            wellbeing: 5.91,
            overall: 6.024,
            collaboration: 5.03,
        },
        {
            datetime: "2023-06-19 00:00:00",
            wellbeing: 6.51,
            rank: "104",
            overall: 6.078,
            work: 6.863,
            collaboration: 4.47,
        },
        {
            datetime: "2023-06-20 00:00:00",
            wellbeing: 7.02,
            rank: "101",
            collaboration: 4.15,
            overall: 6.044,
            work: 6.657,
        },
        {
            datetime: "2023-06-21 00:00:00",
            collaboration: 4.14,
            rank: "95",
            overall: 6.098,
            work: 6.57,
            wellbeing: 7.35,
        },
        {
            datetime: "2023-06-22 00:00:00",
            work: 6.75,
            rank: "87",
            overall: 6.113,
            wellbeing: 7.23,
            collaboration: 4.04,
        },
        {
            datetime: "2023-06-23 00:00:00",
            work: 6.317,
            rank: "94",
            overall: 5.935,
            collaboration: 3.85,
            wellbeing: 7.45,
        },
        {
            datetime: "2023-06-24 00:00:00",
            overall: 5.943,
            rank: "95",
            wellbeing: 7.45,
            collaboration: 3.85,
            work: 6.333,
        },
        {
            datetime: "2023-06-25 00:00:00",
            work: 6.35,
            rank: "93",
            overall: 5.95,
            wellbeing: 7.45,
            collaboration: 3.85,
        },
        {
            datetime: "2023-06-26 00:00:00",
            work: 6.543,
            rank: "84",
            collaboration: 4.16,
            overall: 6.041,
            wellbeing: 7.17,
        },
        {
            datetime: "2023-06-27 00:00:00",
            overall: 5.933,
            rank: "91",
            collaboration: 4.3,
            work: 6.603,
            wellbeing: 6.56,
        },
        {
            datetime: "2023-06-28 00:00:00",
            work: 6.417,
            rank: "90",
            collaboration: 4.12,
            overall: 5.895,
            wellbeing: 6.89,
        },
        {
            datetime: "2023-06-29 00:00:00",
            collaboration: 4.09,
            rank: "89",
            overall: 5.884,
            wellbeing: 7.07,
            work: 6.29,
        },
        {
            datetime: "2023-06-30 00:00:00",
            collaboration: 4.59,
            rank: "69",
            wellbeing: 7.36,
            overall: 6.324,
            work: 6.79,
        },
        {
            datetime: "2023-07-01 00:00:00",
            wellbeing: 7.36,
            rank: "66",
            collaboration: 4.59,
            overall: 6.368,
            work: 6.893,
        },
        {
            datetime: "2023-07-02 00:00:00",
            work: 6.987,
            rank: "66",
            wellbeing: 7.36,
            collaboration: 4.59,
            overall: 6.408,
        },
        {
            datetime: "2023-07-03 00:00:00",
            overall: 6.565,
            rank: "60",
            collaboration: 4.77,
            work: 7.386,
            wellbeing: 7.13,
        },
        {
            datetime: "2023-07-04 00:00:00",
            collaboration: 4.98,
            rank: "65",
            overall: 6.622,
            work: 7.386,
            wellbeing: 7.12,
        },
        {
            datetime: "2023-07-05 00:00:00",
            work: 7.695,
            rank: "60",
            collaboration: 5.08,
            wellbeing: 6.42,
            overall: 6.583,
        },
        {
            datetime: "2023-07-06 00:00:00",
            wellbeing: 5.97,
            rank: "66",
            collaboration: 5.42,
            work: 7.972,
            overall: 6.671,
        },
        {
            datetime: "2023-07-07 00:00:00",
            wellbeing: 5.62,
            rank: "66",
            work: 7.799,
            collaboration: 5.3,
            overall: 6.462,
        },
        {
            datetime: "2023-07-08 00:00:00",
            collaboration: 5.3,
            rank: "74",
            work: 7.78,
            overall: 6.454,
            wellbeing: 5.62,
        },
        {
            datetime: "2023-07-09 00:00:00",
            wellbeing: 5.62,
            rank: "81",
            work: 7.76,
            collaboration: 5.3,
            overall: 6.446,
        },
        {
            datetime: "2023-07-10 00:00:00",
            collaboration: 5.21,
            rank: "80",
            overall: 6.483,
            wellbeing: 6.11,
            work: 7.58,
        },
        {
            datetime: "2023-07-11 00:00:00",
            collaboration: 5.07,
            rank: "95",
            wellbeing: 6.23,
            overall: 6.468,
            work: 7.56,
        },
        {
            datetime: "2023-07-12 00:00:00",
            overall: 6.374,
            rank: "92",
            wellbeing: 6.67,
            collaboration: 5.02,
            work: 7.08,
        },
        {
            datetime: "2023-07-13 00:00:00",
            wellbeing: 7.12,
            rank: "87",
            overall: 6.274,
            collaboration: 4.84,
            work: 6.667,
        },
        {
            datetime: "2023-07-14 00:00:00",
            collaboration: 4.58,
            rank: "77",
            wellbeing: 7.48,
            overall: 6.323,
            work: 6.714,
        },
        {
            datetime: "2023-07-15 00:00:00",
            collaboration: 4.58,
            rank: "73",
            work: 6.714,
            wellbeing: 7.48,
            overall: 6.323,
        },
        {
            datetime: "2023-07-16 00:00:00",
            overall: 6.323,
            rank: "74",
            wellbeing: 7.48,
            collaboration: 4.58,
            work: 6.714,
        },
        {
            datetime: "2023-07-17 00:00:00",
            work: 6.407,
            rank: "90",
            collaboration: 4.42,
            wellbeing: 6.98,
            overall: 6.003,
        },
        {
            datetime: "2023-07-18 00:00:00",
            work: 6.534,
            rank: "74",
            wellbeing: 7.15,
            overall: 6.057,
            collaboration: 4.25,
        },
        {
            datetime: "2023-07-19 00:00:00",
            collaboration: 3.93,
            rank: "70",
            overall: 6.126,
            wellbeing: 7.4,
            work: 6.74,
        },
        {
            datetime: "2023-07-20 00:00:00",
            wellbeing: 7.62,
            rank: "67",
            work: 6.834,
            overall: 6.194,
            collaboration: 3.81,
        },
        {
            datetime: "2023-07-21 00:00:00",
            collaboration: 3.88,
            rank: "69",
            overall: 6.246,
            wellbeing: 7.67,
            work: 6.874,
        },
        {
            datetime: "2023-07-22 00:00:00",
            wellbeing: 7.67,
            rank: "72",
            work: 6.874,
            collaboration: 3.88,
            overall: 6.246,
        },
        {
            datetime: "2023-07-23 00:00:00",
            collaboration: 3.88,
            rank: "70",
            overall: 6.246,
            work: 6.874,
            wellbeing: 7.67,
        },
        {
            datetime: "2023-07-24 00:00:00",
            wellbeing: 7.76,
            rank: "55",
            overall: 6.457,
            collaboration: 3.91,
            work: 7.287,
        },
        {
            datetime: "2023-07-25 00:00:00",
            wellbeing: 7.5,
            rank: "71",
            work: 7.04,
            collaboration: 4.17,
            overall: 6.351,
        },
        {
            datetime: "2023-07-26 00:00:00",
            overall: 6.191,
            rank: "76",
            collaboration: 4.46,
            wellbeing: 7.06,
            work: 6.767,
        },
        {
            datetime: "2023-07-27 00:00:00",
            work: 6.94,
            rank: "68",
            wellbeing: 7.06,
            collaboration: 4.64,
            overall: 6.317,
        },
        {
            datetime: "2023-07-28 00:00:00",
            wellbeing: 7,
            rank: "71",
            collaboration: 4.76,
            work: 6.94,
            overall: 6.334,
        },
        {
            datetime: "2023-07-29 00:00:00",
            overall: 6.334,
            rank: "69",
            wellbeing: 7,
            work: 6.94,
            collaboration: 4.76,
        },
        {
            datetime: "2023-07-30 00:00:00",
            wellbeing: 7,
            rank: "70",
            collaboration: 4.76,
            work: 6.94,
            overall: 6.334,
        },
        {
            datetime: "2023-07-31 00:00:00",
            work: 6.84,
            rank: "60",
            overall: 6.371,
            collaboration: 5.02,
            wellbeing: 7.02,
        },
        {
            datetime: "2023-08-01 00:00:00",
            collaboration: 4.73,
            rank: "41",
            overall: 6.528,
            work: 7.3,
            wellbeing: 7.17,
        },
        {
            datetime: "2023-08-02 00:00:00",
            wellbeing: 7.38,
            rank: "29",
            work: 7.9,
            collaboration: 4.72,
            overall: 6.843,
        },
        {
            datetime: "2023-08-03 00:00:00",
            overall: 6.763,
            rank: "38",
            collaboration: 4.58,
            wellbeing: 7.02,
            work: 8.047,
        },
        {
            datetime: "2023-08-04 00:00:00",
            collaboration: 4.58,
            rank: "35",
            work: 8.42,
            overall: 6.854,
            wellbeing: 6.78,
        },
        {
            datetime: "2023-08-05 00:00:00",
            wellbeing: 6.78,
            rank: "32",
            work: 8.42,
            overall: 6.854,
            collaboration: 4.58,
        },
        {
            datetime: "2023-08-06 00:00:00",
            work: 8.42,
            rank: "34",
            collaboration: 4.58,
            overall: 6.854,
            wellbeing: 6.78,
        },
        {
            datetime: "2023-08-07 00:00:00",
            overall: 6.843,
            rank: "42",
            wellbeing: 6.99,
            work: 8.4,
            collaboration: 4.36,
        },
        {
            datetime: "2023-08-08 00:00:00",
            work: 8.4,
            rank: "34",
            overall: 6.943,
            wellbeing: 7.12,
            collaboration: 4.58,
        },
        {
            datetime: "2023-08-09 00:00:00",
            work: 8.04,
            rank: "47",
            collaboration: 4.13,
            overall: 6.651,
            wellbeing: 7.09,
        },
        {
            datetime: "2023-08-10 00:00:00",
            overall: 6.737,
            rank: "43",
            work: 8.24,
            wellbeing: 7.14,
            collaboration: 4.08,
        },
        {
            datetime: "2023-08-11 00:00:00",
            overall: 6.737,
            rank: "43",
            collaboration: 4.33,
            work: 8.207,
            wellbeing: 6.94,
        },
        {
            datetime: "2023-08-12 00:00:00",
            collaboration: 4.33,
            rank: "42",
            overall: 6.745,
            work: 8.226,
            wellbeing: 6.94,
        },
        {
            datetime: "2023-08-13 00:00:00",
            overall: 6.753,
            rank: "40",
            work: 8.245,
            collaboration: 4.33,
            wellbeing: 6.94,
        },
        {
            datetime: "2023-08-14 00:00:00",
            overall: 6.213,
            rank: "57",
            work: 7.232,
            wellbeing: 7.19,
            collaboration: 3.71,
        },
        {
            datetime: "2023-08-15 00:00:00",
            overall: 5.665,
            rank: "77",
            wellbeing: 7.55,
            collaboration: 3.29,
            work: 5.992,
        },
        {
            datetime: "2023-08-16 00:00:00",
            wellbeing: 7.87,
            rank: "96",
            overall: 5.273,
            collaboration: 3.01,
            work: 5.052,
        },
        {
            datetime: "2023-08-17 00:00:00",
            wellbeing: 8.24,
            rank: "132",
            overall: 4.702,
            collaboration: 2.56,
            work: 3.772,
        },
        {
            datetime: "2023-08-18 00:00:00",
            wellbeing: 8.74,
            rank: "176",
            work: 2.473,
            overall: 4.074,
            collaboration: 1.81,
        },
        {
            datetime: "2023-08-19 00:00:00",
            wellbeing: 8.74,
            rank: "176",
            collaboration: 1.81,
            overall: 4.04,
            work: 2.395,
        },
        {
            datetime: "2023-08-20 00:00:00",
            overall: 3.946,
            rank: "182",
            work: 2.175,
            wellbeing: 8.74,
            collaboration: 1.81,
        },
        {
            datetime: "2023-08-21 00:00:00",
            overall: 4.323,
            rank: "142",
            wellbeing: 8.22,
            collaboration: 2.47,
            work: 2.961,
        },
        {
            datetime: "2023-08-22 00:00:00",
            overall: 4.926,
            rank: "119",
            wellbeing: 7.82,
            collaboration: 3.08,
            work: 4.228,
        },
        {
            datetime: "2023-08-23 00:00:00",
            overall: 5.529,
            rank: "85",
            wellbeing: 7.47,
            work: 5.361,
            collaboration: 3.84,
        },
        {
            datetime: "2023-08-24 00:00:00",
            work: 5.46,
            rank: "82",
            wellbeing: 7.43,
            overall: 5.717,
            collaboration: 4.39,
        },
        {
            datetime: "2023-08-25 00:00:00",
            wellbeing: 7.43,
            rank: "59",
            work: 6.754,
            collaboration: 4.7,
            overall: 6.36,
        },
        {
            datetime: "2023-08-26 00:00:00",
            overall: 6.424,
            rank: "56",
            work: 6.903,
            collaboration: 4.7,
            wellbeing: 7.43,
        },
        {
            datetime: "2023-08-27 00:00:00",
            work: 7.049,
            rank: "57",
            overall: 6.486,
            wellbeing: 7.43,
            collaboration: 4.7,
        },
        {
            datetime: "2023-08-28 00:00:00",
            overall: 6.443,
            rank: "65",
            wellbeing: 7.76,
            work: 7.095,
            collaboration: 4.15,
        },
        {
            datetime: "2023-08-29 00:00:00",
            wellbeing: 8.18,
            rank: "75",
            collaboration: 4.04,
            work: 6.655,
            overall: 6.343,
        },
        {
            datetime: "2023-08-30 00:00:00",
            work: 6.422,
            rank: "93",
            wellbeing: 8.47,
            collaboration: 3.4,
            overall: 6.143,
        },
        {
            datetime: "2023-08-31 00:00:00",
            collaboration: 3.51,
            rank: "87",
            work: 7.119,
            overall: 6.353,
            wellbeing: 8.05,
        },
        {
            datetime: "2023-09-01 00:00:00",
            work: 7.099,
            rank: "92",
            overall: 6.345,
            wellbeing: 7.98,
            collaboration: 3.58,
        },
        {
            datetime: "2023-09-02 00:00:00",
            work: 7.191,
            rank: "90",
            collaboration: 3.58,
            overall: 6.384,
            wellbeing: 7.98,
        },
        {
            datetime: "2023-09-03 00:00:00",
            collaboration: 3.58,
            rank: "90",
            wellbeing: 7.98,
            overall: 6.422,
            work: 7.279,
        },
        {
            datetime: "2023-09-04 00:00:00",
            collaboration: 4.06,
            rank: "76",
            overall: 6.72,
            wellbeing: 8.14,
            work: 7.548,
        },
        {
            datetime: "2023-09-05 00:00:00",
            collaboration: 4.15,
            rank: "82",
            overall: 6.537,
            work: 7.448,
            wellbeing: 7.56,
        },
        {
            datetime: "2023-09-06 00:00:00",
            wellbeing: 6.88,
            rank: "88",
            collaboration: 4.69,
            overall: 6.44,
            work: 7.315,
        },
        {
            datetime: "2023-09-07 00:00:00",
            collaboration: 4.73,
            rank: "84",
            overall: 6.475,
            work: 7.361,
            wellbeing: 6.89,
        },
        {
            datetime: "2023-09-08 00:00:00",
            wellbeing: 6.93,
            rank: "107",
            overall: 6.182,
            work: 6.565,
            collaboration: 4.86,
        },
        {
            datetime: "2023-09-09 00:00:00",
            wellbeing: 6.93,
            rank: "106",
            overall: 6.106,
            work: 6.389,
            collaboration: 4.86,
        },
        {
            datetime: "2023-09-10 00:00:00",
            work: 5.896,
            rank: "110",
            collaboration: 4.86,
            wellbeing: 6.93,
            overall: 5.895,
        },
        {
            datetime: "2023-09-11 00:00:00",
            work: 4.729,
            rank: "149",
            collaboration: 5,
            overall: 5.304,
            wellbeing: 6.47,
        },
        {
            datetime: "2023-09-12 00:00:00",
            wellbeing: 7.05,
            rank: "131",
            overall: 5.478,
            collaboration: 4.27,
            work: 5.236,
        },
        {
            datetime: "2023-09-13 00:00:00",
            collaboration: 3.94,
            rank: "122",
            overall: 5.612,
            wellbeing: 7.76,
            work: 5.296,
        },
        {
            datetime: "2023-09-14 00:00:00",
            overall: 5.581,
            rank: "129",
            work: 5.269,
            wellbeing: 7.9,
            collaboration: 3.73,
        },
        {
            datetime: "2023-09-15 00:00:00",
            work: 6.202,
            rank: "112",
            wellbeing: 7.86,
            collaboration: 3.68,
            overall: 5.955,
        },
        {
            datetime: "2023-09-16 00:00:00",
            collaboration: 3.68,
            rank: "114",
            overall: 5.955,
            work: 6.202,
            wellbeing: 7.86,
        },
        {
            datetime: "2023-09-17 00:00:00",
            collaboration: 3.68,
            rank: "114",
            overall: 5.955,
            work: 6.202,
            wellbeing: 7.86,
        },
        {
            datetime: "2023-09-18 00:00:00",
            overall: 6.418,
            rank: "89",
            collaboration: 4.16,
            wellbeing: 7.67,
            work: 7.089,
        },
        {
            datetime: "2023-09-19 00:00:00",
            work: 6.616,
            rank: "102",
            wellbeing: 7.2,
            overall: 6.161,
            collaboration: 4.44,
        },
        {
            datetime: "2023-09-20 00:00:00",
            wellbeing: 7.16,
            rank: "136",
            work: 5.729,
            collaboration: 4.8,
            overall: 5.872,
        },
        {
            datetime: "2023-09-21 00:00:00",
            collaboration: 4.93,
            rank: "161",
            work: 4.849,
            wellbeing: 7.07,
            overall: 5.506,
        },
        {
            datetime: "2023-09-22 00:00:00",
            collaboration: 5.38,
            rank: "159",
            overall: 5.624,
            wellbeing: 6.72,
            work: 5.056,
        },
        {
            datetime: "2023-09-23 00:00:00",
            wellbeing: 6.72,
            rank: "158",
            work: 5.149,
            overall: 5.664,
            collaboration: 5.38,
        },
        {
            datetime: "2023-09-24 00:00:00",
            wellbeing: 6.72,
            rank: "153",
            overall: 5.704,
            collaboration: 5.38,
            work: 5.242,
        },
        {
            datetime: "2023-09-25 00:00:00",
            work: 5.289,
            rank: "143",
            overall: 5.735,
            collaboration: 5.05,
            wellbeing: 7.09,
        },
        {
            datetime: "2023-09-26 00:00:00",
            overall: 5.889,
            rank: "127",
            collaboration: 5.11,
            wellbeing: 7.21,
            work: 5.529,
        },
        {
            datetime: "2023-09-27 00:00:00",
            wellbeing: 6.91,
            rank: "107",
            overall: 6.175,
            collaboration: 5.23,
            work: 6.316,
        },
        {
            datetime: "2023-09-28 00:00:00",
            wellbeing: 7.26,
            rank: "80",
            overall: 6.649,
            collaboration: 5.06,
            work: 7.302,
        },
        {
            datetime: "2023-09-29 00:00:00",
            work: 6.969,
            rank: "91",
            wellbeing: 7.27,
            overall: 6.409,
            collaboration: 4.71,
        },
        {
            datetime: "2023-09-30 00:00:00",
            wellbeing: 7.27,
            rank: "79",
            work: 7.079,
            overall: 6.456,
            collaboration: 4.71,
        },
        {
            datetime: "2023-10-01 00:00:00",
            collaboration: 4.71,
            rank: "74",
            overall: 6.475,
            work: 7.122,
            wellbeing: 7.27,
        },
        {
            datetime: "2023-10-02 00:00:00",
            collaboration: 4.36,
            rank: "84",
            overall: 6.398,
            work: 6.949,
            wellbeing: 7.61,
        },
        {
            datetime: "2023-10-03 00:00:00",
            overall: 6.478,
            rank: "86",
            work: 7.189,
            collaboration: 4.49,
            wellbeing: 7.4,
        },
        {
            datetime: "2023-10-04 00:00:00",
            wellbeing: 7.68,
            rank: "91",
            collaboration: 4.09,
            overall: 6.423,
            work: 7.142,
        },
        {
            datetime: "2023-10-05 00:00:00",
            overall: 6.298,
            rank: "106",
            wellbeing: 7.7,
            work: 7.062,
            collaboration: 3.75,
        },
        {
            datetime: "2023-10-06 00:00:00",
            work: 7.469,
            rank: "111",
            collaboration: 3.58,
            overall: 6.438,
            wellbeing: 7.75,
        },
        {
            datetime: "2023-10-07 00:00:00",
            wellbeing: 7.75,
            rank: "115",
            collaboration: 3.58,
            overall: 6.408,
            work: 7.4,
        },
        {
            datetime: "2023-10-08 00:00:00",
            collaboration: 3.58,
            rank: "116",
            wellbeing: 7.75,
            work: 7.333,
            overall: 6.38,
        },
        {
            datetime: "2023-10-09 00:00:00",
            wellbeing: 7.7,
            rank: "99",
            overall: 6.585,
            work: 7.793,
            collaboration: 3.66,
        },
        {
            datetime: "2023-10-10 00:00:00",
            work: 7.64,
            rank: "92",
            collaboration: 3.72,
            overall: 6.605,
            wellbeing: 7.94,
        },
        {
            datetime: "2023-10-11 00:00:00",
            wellbeing: 7.98,
            rank: "109",
            work: 6.798,
            collaboration: 4.03,
            overall: 6.345,
        },
        {
            datetime: "2023-10-12 00:00:00",
            work: 5.839,
            rank: "135",
            overall: 6.019,
            wellbeing: 7.61,
            collaboration: 4.7,
        },
        {
            datetime: "2023-10-13 00:00:00",
            overall: 6.074,
            rank: "119",
            collaboration: 5.04,
            wellbeing: 7.43,
            work: 5.859,
        },
        {
            datetime: "2023-10-14 00:00:00",
            collaboration: 5.04,
            rank: "121",
            work: 5.79,
            overall: 6.044,
            wellbeing: 7.43,
        },
        {
            datetime: "2023-10-15 00:00:00",
            wellbeing: 7.43,
            rank: "119",
            collaboration: 5.04,
            work: 5.727,
            overall: 6.017,
        },
        {
            datetime: "2023-10-16 00:00:00",
            work: 5.5,
            rank: "124",
            collaboration: 5.06,
            wellbeing: 6.93,
            overall: 5.783,
        },
        {
            datetime: "2023-10-17 00:00:00",
            overall: 5.657,
            rank: "137",
            wellbeing: 6.89,
            work: 5.213,
            collaboration: 5.09,
        },
        {
            datetime: "2023-10-18 00:00:00",
            wellbeing: 6.34,
            rank: "116",
            overall: 5.96,
            work: 6.113,
            collaboration: 5.35,
        },
        {
            datetime: "2023-10-19 00:00:00",
            wellbeing: 6.08,
            rank: "85",
            collaboration: 5.54,
            overall: 6.374,
            work: 7.127,
        },
        {
            datetime: "2023-10-20 00:00:00",
            wellbeing: 6.56,
            rank: "105",
            overall: 6.191,
            work: 6.46,
            collaboration: 5.42,
        },
        {
            datetime: "2023-10-21 00:00:00",
            wellbeing: 6.56,
            rank: "107",
            overall: 6.177,
            collaboration: 5.42,
            work: 6.426,
        },
        {
            datetime: "2023-10-22 00:00:00",
            work: 6.382,
            rank: "108",
            collaboration: 5.42,
            wellbeing: 6.56,
            overall: 6.158,
        },
        {
            datetime: "2023-10-23 00:00:00",
            collaboration: 5.41,
            rank: "105",
            wellbeing: 7.11,
            overall: 6.261,
            work: 6.262,
        },
        {
            datetime: "2023-10-24 00:00:00",
            overall: 6.109,
            rank: "110",
            work: 6.396,
            wellbeing: 6.29,
            collaboration: 5.5,
        },
        {
            datetime: "2023-10-25 00:00:00",
            overall: 6.115,
            rank: "109",
            work: 6.562,
            collaboration: 5.59,
            wellbeing: 5.97,
        },
        {
            datetime: "2023-10-26 00:00:00",
            collaboration: 4.92,
            rank: "107",
            wellbeing: 6.59,
            overall: 6.186,
            work: 6.762,
        },
        {
            datetime: "2023-10-27 00:00:00",
            work: 7.462,
            rank: "105",
            overall: 6.369,
            collaboration: 5,
            wellbeing: 6.1,
        },
        {
            datetime: "2023-10-28 00:00:00",
            work: 7.462,
            rank: "104",
            collaboration: 5,
            overall: 6.369,
            wellbeing: 6.1,
        },
        {
            datetime: "2023-10-29 00:00:00",
            work: 7.462,
            rank: "104",
            overall: 6.369,
            wellbeing: 6.1,
            collaboration: 5,
        },
        {
            datetime: "2023-10-30 00:00:00",
            collaboration: 4.38,
            rank: "106",
            overall: 6.275,
            work: 7.676,
            wellbeing: 6.07,
        },
        {
            datetime: "2023-10-31 00:00:00",
            overall: 6.401,
            rank: "112",
            work: 7.716,
            collaboration: 3.61,
            wellbeing: 7.22,
        },
        {
            datetime: "2023-11-01 00:00:00",
            work: 6.529,
            rank: "137",
            wellbeing: 7.74,
            overall: 5.932,
            collaboration: 3.23,
        },
        {
            datetime: "2023-11-02 00:00:00",
            overall: 5.352,
            rank: "166",
            collaboration: 3.39,
            work: 5.202,
            wellbeing: 7.54,
        },
        {
            datetime: "2023-11-03 00:00:00",
            overall: 5.244,
            rank: "165",
            work: 4.896,
            collaboration: 3.4,
            wellbeing: 7.61,
        },
        {
            datetime: "2023-11-04 00:00:00",
            work: 5.056,
            rank: "165",
            overall: 5.312,
            collaboration: 3.4,
            wellbeing: 7.61,
        },
        {
            datetime: "2023-11-05 00:00:00",
            work: 5.216,
            rank: "166",
            overall: 5.381,
            collaboration: 3.4,
            wellbeing: 7.61,
        },
        {
            datetime: "2023-11-06 00:00:00",
            work: 5.028,
            rank: "160",
            overall: 5.217,
            wellbeing: 7.62,
            collaboration: 3.1,
        },
        {
            datetime: "2023-11-07 00:00:00",
            collaboration: 3.55,
            rank: "148",
            work: 4.995,
            overall: 5.326,
            wellbeing: 7.6,
        },
        {
            datetime: "2023-11-08 00:00:00",
            wellbeing: 7.43,
            rank: "109",
            work: 6.272,
            overall: 5.908,
            collaboration: 3.84,
        },
        {
            datetime: "2023-11-09 00:00:00",
            work: 7.476,
            overall: 6.444,
            wellbeing: 7.1,
            collaboration: 4.24,
            rank: "109",
        },
        {
            datetime: "2023-11-10 00:00:00",
            overall: 6.481,
            work: 7.596,
            collaboration: 4.26,
            wellbeing: 7.03,
            rank: "119",
        },
        {
            datetime: "2023-11-11 00:00:00",
            overall: 6.451,
            collaboration: 4.26,
            wellbeing: 7.03,
            work: 7.527,
            rank: "99",
        },
        {
            datetime: "2023-11-12 00:00:00",
            collaboration: 4.26,
            overall: 6.412,
            work: 7.436,
            wellbeing: 7.03,
            rank: "100",
        },
        {
            datetime: "2023-11-13 00:00:00",
            wellbeing: 6.62,
            collaboration: 5.24,
            work: 7.699,
            overall: 6.688,
            rank: "101",
        },
        {
            datetime: "2023-11-14 00:00:00",
            work: 7.939,
            overall: 6.739,
            wellbeing: 6.36,
            collaboration: 5.32,
            rank: "90",
        },
        {
            datetime: "2023-11-15 00:00:00",
            collaboration: 5,
            overall: 6.431,
            work: 7.419,
            wellbeing: 6.38,
            rank: "80",
        },
        {
            datetime: "2023-11-16 00:00:00",
            wellbeing: 6.46,
            overall: 6.293,
            work: 7.312,
            collaboration: 4.6,
            rank: "78",
        },
        {
            datetime: "2023-11-17 00:00:00",
            collaboration: 4.49,
            overall: 6.302,
            work: 7.352,
            wellbeing: 6.54,
            rank: "72",
        },
        {
            datetime: "2023-11-18 00:00:00",
            overall: 6.296,
            work: 7.338,
            wellbeing: 6.54,
            collaboration: 4.49,
            rank: "65",
        },
        {
            datetime: "2023-11-19 00:00:00",
            overall: 6.289,
            collaboration: 4.49,
            work: 7.321,
            wellbeing: 6.54,
            rank: "55",
        },
        {
            datetime: "2023-11-20 00:00:00",
            work: 7.288,
            collaboration: 4.57,
            wellbeing: 6.59,
            overall: 6.312,
            rank: "45",
        },
        {
            datetime: "2023-11-21 00:00:00",
            work: 6.861,
            wellbeing: 6.9,
            overall: 6.052,
            collaboration: 3.99,
            rank: "40",
        },
        {
            datetime: "2023-11-22 00:00:00",
            wellbeing: 7.38,
            work: 7.321,
            overall: 6.286,
            collaboration: 3.64,
            rank: "32",
        },
        {
            datetime: "2023-11-23 00:00:00",
            collaboration: 4.05,
            overall: 6.423,
            work: 7.408,
            wellbeing: 7.32,
            rank: "38",
        },
        {
            datetime: "2023-11-24 00:00:00",
            overall: 6.466,
            collaboration: 4.15,
            work: 7.481,
            wellbeing: 7.26,
            rank: "40",
        },
        {
            datetime: "2023-11-25 00:00:00",
            overall: 6.464,
            collaboration: 4.15,
            wellbeing: 7.26,
            work: 7.476,
            rank: "48",
        },
        {
            datetime: "2023-11-26 00:00:00",
            collaboration: 4.345,
            overall: 6.313,
            work: 7.474,
            wellbeing: 6.54,
        },
        {
            datetime: "2023-11-27 00:00:00",
            wellbeing: 6.67,
            overall: 5.74,
            collaboration: 4.215,
            work: 6.138,
            rank: "52",
        },
        {
            datetime: "2023-11-28 00:00:00",
            wellbeing: 6.16,
            work: 6.565,
            collaboration: 5.177,
            overall: 6.053,
            rank: "48",
        },
        {
            datetime: "2023-11-29 00:00:00",
            overall: 6.073,
            collaboration: 5.807,
            wellbeing: 5.87,
            work: 6.385,
            rank: "46",
        },
        {
            datetime: "2023-11-30 00:00:00",
            work: 5.025,
            collaboration: 5.757,
            overall: 5.504,
            wellbeing: 5.97,
            rank: "42",
        },
        {
            datetime: "2023-12-01 00:00:00",
            overall: 5.447,
            collaboration: 5.827,
            work: 4.678,
            wellbeing: 6.22,
            rank: "40",
        },
        {
            datetime: "2023-12-02 00:00:00",
            overall: 5.45,
            work: 4.685,
            collaboration: 5.827,
            wellbeing: 6.22,
            rank: "52",
        },
        {
            datetime: "2023-12-03 00:00:00",
            wellbeing: 6.91,
            work: 4.685,
            overall: 5.613,
            collaboration: 5.71,
            rank: "55",
        },
        {
            datetime: "2023-12-04 00:00:00",
            work: 5.703,
            overall: 6.021,
            wellbeing: 6.75,
            collaboration: 5.77,
            rank: "51",
        },
        {
            datetime: "2023-12-05 00:00:00",
            wellbeing: 6.73,
            work: 5.376,
            collaboration: 5.15,
            overall: 5.698,
            rank: "50",
        },
        {
            datetime: "2023-12-06 00:00:00",
            overall: 5.687,
            collaboration: 4.51,
            wellbeing: 7.25,
            work: 5.43,
            rank: "48",
        },
    ],
};

const getOverview = () => {
    return indexes;
};

export default getOverview;
